import { throwRepoErrorFromApiV3Error } from '@webapp/core/utils/repositories/throwRepoErrorFromApiV3Error'
import { type RepoPaginatedResponse } from '@webapp/infrastructure/interfaces/repositories/RepoPaginatedResponse'
import { type IHttpClient } from '@webapp/infrastructure/interfaces/services/IHttpClient'
import { mapV1UserApiModel } from '@webapp/platform/iam/data-access/mapper/mapV1UserApiModel'
import { type GetActiveUsersResponse } from '@webapp/platform/iam/data-access/types/GetActiveUsersResponse'
import { type V1UserConstructor } from '@webapp/platform/iam/entities/V1User'

interface Dependency {
  httpClient: IHttpClient
}

interface ListActiveUsersParams {
  limit?: number
  offset?: number
  search?: string
  sort?: string
}

export class V1UserRepository {
  constructor(private readonly deps: Dependency) {}

  async listActiveUsers(
    params?: ListActiveUsersParams
  ): Promise<RepoPaginatedResponse<V1UserConstructor, { offset: number }>> {
    try {
      const res = await this.deps.httpClient.get<GetActiveUsersResponse>(
        `/api/user/active/`,
        {
          params: {
            limit: params?.limit,
            offset: params?.offset,
            search: params?.search,
            sort: params?.sort,
          },
        }
      )

      const users = res.data.data
      const paging = res.data.paging

      return {
        data: users.map((user) => mapV1UserApiModel(user)),
        pagination: {
          count: paging.count,
          page: paging.page,
          pageSize: paging.limit,
          numPages: paging.pages.length,
        },
        metadata: {
          offset: paging.offset,
        },
      }
    } catch (err) {
      throw throwRepoErrorFromApiV3Error(err)
    }
  }
}
